import { createContext } from 'react';

export interface SidebarCollapseContextType {
  isCollapsed: boolean;
  toggleSidebar: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

export const SidebarCollapseContext = createContext<
  SidebarCollapseContextType | undefined
>(undefined);
